// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrDetailsRequestDto
 */
export interface IOcrDetailsRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrDetailsRequestDto
     */
    patient: string;
    /**
     * 
     * @type {number}
     * @memberof IOcrDetailsRequestDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrDetailsRequestDto
     */
    facility_name: string;
    /**
     * 
     * @type {Date}
     * @memberof IOcrDetailsRequestDto
     */
    service_date: Date;
    /**
     * 
     * @type {number}
     * @memberof IOcrDetailsRequestDto
     */
    service_id: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof IOcrDetailsRequestDto
     */
    account_ids?: Array<number>;
}

/**
 * Check if a given object implements the IOcrDetailsRequestDto interface.
 */
export function instanceOfIOcrDetailsRequestDto(value: object): value is IOcrDetailsRequestDto {
    if (!('patient' in value) || value['patient'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('facility_name' in value) || value['facility_name'] === undefined) return false;
    if (!('service_date' in value) || value['service_date'] === undefined) return false;
    if (!('service_id' in value) || value['service_id'] === undefined) return false;
    return true;
}

export function IOcrDetailsRequestDtoFromJSON(json: any): IOcrDetailsRequestDto {
    return IOcrDetailsRequestDtoFromJSONTyped(json, false);
}

export function IOcrDetailsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrDetailsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patient': json['patient'],
        'amount': json['amount'],
        'facility_name': json['facility_name'],
        'service_date': (new Date(json['service_date'])),
        'service_id': json['service_id'],
        'account_ids': json['account_ids'] == null ? undefined : json['account_ids'],
    };
}

export function IOcrDetailsRequestDtoToJSON(json: any): IOcrDetailsRequestDto {
    return IOcrDetailsRequestDtoToJSONTyped(json, false);
}

export function IOcrDetailsRequestDtoToJSONTyped(value?: IOcrDetailsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient': value['patient'],
        'amount': value['amount'],
        'facility_name': value['facility_name'],
        'service_date': ((value['service_date']).toISOString().substring(0,10)),
        'service_id': value['service_id'],
        'account_ids': value['account_ids'],
    };
}

